<form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
  <a [href]="coverletterLink" target="_blank"
    >{{ taxpayerAlias }} {{ noticeTypeName }} Cover Letter</a
  >
  @if (paygFormLink) {
  <a [href]="paygFormLink" target="_blank">{{ taxpayerAlias }} PAYG Form</a>
  }
  <h1>Email to {{ taxpayerAlias }}</h1>

  @if (hasSent) {
  <div>
    <h3>The email will be sent to the {{ taxpayerAlias }}.</h3>
  </div>
  } @if (!hasSent) {
  <div>
    <div class="btn-group">
      <button
        class="ui background button"
        id="saveBtn"
        [ngClass]="{ loading: isSaving }"
        [disabled]="emailForm.pristine || isSaving"
        (click)="saveEmail()"
      >
        Save
      </button>
      <button
        class="ui primary background button"
        id="sendBtn"
        [disabled]="emailForm.invalid || isSaving"
        type="submit"
      >
        Send
      </button>
    </div>
    <label>
      <span class="field-name">To</span>
      <input formControlName="mailTo" />
    </label>
    @if (emailForm.controls['mailTo'].invalid &&
    (emailForm.controls['mailTo'].dirty ||
    emailForm.controls['mailTo'].touched)) {
    <div class="alert-danger">
      Email address is required
    </div>
    }
    <label>
      <span class="field-name">Cc</span>
      <input formControlName="mailCc" />
    </label>
    <label>
      <span class="field-name">Subject</span>
      <input formControlName="subject" />
    </label>
    <textarea class="field-name" formControlName="body"></textarea>
  </div>
  }
</form>

<div
  #emailConfirmationModal
  id="email-confirmation-modal"
  class="ui tiny modal"
>
  <div class="icon modal-close close"></div>

  <h2>Are you sure?</h2>
  <div class="content">
    Please confirm you want to send this email to
    <b>{{ emailForm.value.mailTo }}</b>
  </div>

  <div class="content link-notification">
    <input type="checkbox" [(ngModel)]="sendLinkConfirmation" />
    <span>Send LINK confirmation email</span>
  </div>

  <div class="actions">
    <div
      (click)="sendEmail()"
      class="ui primary background button"
      [ngClass]="{ loading: isLoading }"
    >
      Send email and upload to KPMG LINK
    </div>
  </div>
</div>
